
import React from 'react';

export function PageContentSection({ 
  title, 
  icon: Icon, 
  content, 
  bgClass, 
  children,
  analyticsId 
}) {
  return (
    <div 
      className="bg-white rounded-xl shadow-sm overflow-hidden"
      data-analytics-id={analyticsId}
    >
      <div className={`${bgClass} p-4 border-b border-gray-100`}>
        <div className="flex items-center">
          <Icon className="w-5 h-5 text-gray-600 mr-2" />
          <h3 className="font-semibold text-gray-900">{title}</h3>
        </div>
      </div>
      <div className="p-4">
        {content && (
          <p className="text-gray-600 text-sm leading-relaxed">{content}</p>
        )}
        {children}
      </div>
    </div>
  );
}
